import { createReducer, on } from '@ngrx/store';
import { UserStaffInfo } from '@src/suite/common/data-models/service/user-staff-info';
import moment from 'moment';

import { HelloResultsActions } from './hello-results.actions';
import { HelloResultsState } from './hello-results.models';

export const initialHelloResultsState: HelloResultsState = {
    ActiveMac: false,
    CentralServer: '',
    ClientFileVersion: '',
    ClientFileVersion7: '',
    ClientVersion: '',
    ClientVersion7: '',
    Expires: new Date(),
    HelpPath: '',
    HomeDatabase: '',
    HomeIP: '',
    HomeProgram: '',
    Monitor: false,
    Printers: null,
    PrivateChannels: null,
    ServerManager: false,
    SessionID: '',
    Supervisor: false,
    UserID: '',
    UserName: '',
    UserStaffInfo: new UserStaffInfo(),
    Navigation: {},
    PSTSuiteNavigation: {},
    CustomCardFields: [],
    PSTNotificationSettings: {
        Email: { Input: '', Recieve: false },
        Mobile: { Recieve: false },
        Phone: { Input: '', Recieve: false },
        Web: { Recieve: false },
    },
    FtpAvatarLocation: '',
    SecurityPrivileges: [],
    PersonalTimeZone: '',
    PersonalLanguage: '',
    TeamExportFormatTemplates: {},
    EnterpriseExportFormatTemplates: {},
    PersonalExportFormatTemplates: {},
    TeamClipboardTemplates: [],
    ClipboardTemplates: [],
    PersonalClipboardTemplates: [],
    Rtl: false,
    DarkMode: false,
    DayOfWeek: 0,
    WalkMe: '',
};

export const defaultLocale = 'en-US';
const extractDateLocale = (locale: string): string => {
    if (!locale) {
        return defaultLocale;
    }
    locale = locale?.toLowerCase().trim();
    // TODO: I need to investigate a beter way to handle this
    if (locale.startsWith('-')) {
        locale = locale.substring(1);
    }
    if (locale.length > 2) {
        const localeArray = locale.split('');
        localeArray.splice(2, 0, '-');
        locale = localeArray.join('');
    }
    if (locale === '') {
        locale = defaultLocale;
    }
    return locale || defaultLocale;
};

const updateDateLocale = (language: string): string => {
    const dateLocale = extractDateLocale(language) || defaultLocale;
    moment.locale(dateLocale);
    return dateLocale;
};

export const helloResultsReducer = createReducer(
    initialHelloResultsState,
    on(HelloResultsActions.setWeekDaySetting, (state, { dayOfWeek }): HelloResultsState => {
        return { ...state, DayOfWeek: dayOfWeek };
    }),
    on(HelloResultsActions.setLanguageSettings, (state, { language }): HelloResultsState => {
        const dateLocale = updateDateLocale(language);
        return {
            ...state,
            PersonalLanguage: language,
            dateLocale,
        };
    })
);
